// https://vuex.vuejs.org/en/actions.html
import axios from 'axios'

export default {
  login ({ commit }, userData) {
    return new Promise((resolve, reject) => {
      commit('auth_request')
      axios
        .post('user/signin', {
          email: userData.email,
          password: userData.password
        })
        .then((response) => {
          const user = response.data.user
          if (user && user.role === 2) {
            localStorage.removeItem('token')
            localStorage.setItem('user', user.email)
            commit('auth_success', { user: user.email })
            resolve(response)
          } else {
            commit('auth_error')
            reject(new Error(400))
          }
        })
        .catch((err) => {
          commit('auth_error')
          reject(err.response ? err.response.status : err)
        })
    })
  },
  restoreSession ({ commit }) {
    localStorage.removeItem('token')

    return axios
      .get('/user/session')
      .then((response) => {
        const user = response.data.user
        localStorage.setItem('user', user.email)
        commit('auth_success', { user: user.email })
      })
      .catch(() => {
        commit('logout')
        localStorage.removeItem('user')
      })
  },
  signup ({ commit }, userData) {
    return new Promise((resolve, reject) => {
      let signUpObject = {}
      signUpObject.firstname = userData.firstname
      signUpObject.lastname = userData.lastname
      signUpObject.email = userData.email
      signUpObject.password = userData.password
      signUpObject.phone = userData.phone
      if (userData.address !== undefined && userData.address !== '') {
        signUpObject.address = userData.address
      }
      if (userData.supplynumber !== undefined && userData.supplynumber !== '') {
        signUpObject.supply_number = userData.supplynumber
      }
      if (userData.kwhprice !== undefined && userData.kwhprice !== '') {
        signUpObject.kwh_price = userData.kwhprice
      }
      if (userData.termsCheckbox !== undefined) {
        signUpObject.accepted_terms = userData.termsCheckbox
      }
      if (userData.extraTermsCheckbox !== undefined) {
        signUpObject.accepted_extra_terms = userData.extraTermsCheckbox
      }
      if (userData.afm !== undefined && userData.afm !== '') {
        signUpObject.afm = userData.afm
      }
      if (userData.affiliation !== undefined && userData.affiliation !== '') {
        signUpObject.affiliation = userData.affiliation
      }

      axios
        .post('/user/signup', signUpObject)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err.response.status)
        })
    })
  },
  validateAcceptTermsToken ({ commit }, token) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/user/accept-terms-validate?token=${token}`)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err.response.status)
        })
    })
  },
  updateTerms ({ commit }, termsData) {
    return new Promise((resolve, reject) => {
      let termsObject = {}
      if (termsData.termsCheckbox !== undefined) {
        termsObject.accepted_terms = termsData.termsCheckbox
      }
      if (termsData.extraTermsCheckbox !== undefined) {
        termsObject.accepted_extra_terms = termsData.extraTermsCheckbox
      }

      axios
        .patch(
          `/user/accept-terms-update?token=${termsData.terms_token}`,
          termsObject
        )
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err.response.status)
        })
    })
  },
  logout ({ commit }) {
    return axios
      .post('/user/logout')
      .catch(() => {})
      .finally(() => {
        commit('logout')
        localStorage.removeItem('user')
      })
  },
  deleteDevice ({ commit }, tableData) {
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({
        url: `${tableData.endpoint}`,
        method: httpmethod
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  addDevice ({ commit }, tableData) {
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({
        url: `${tableData.endpoint}`,
        method: httpmethod,
        data: tableData.tableItem
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  editDevice ({ commit }, tableData) {
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({
        url: `${tableData.endpoint}`,
        method: httpmethod,
        data: tableData.tableItem
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },

  deleteHome ({ commit }, tableData) {
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({
        url: `${tableData.endpoint}`,
        method: httpmethod
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  addHome ({ commit }, tableData) {
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({
        url: `${tableData.endpoint}`,
        method: httpmethod,
        data: tableData.tableItem
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  editHome ({ commit }, tableData) {
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({
        url: `${tableData.endpoint}`,
        method: httpmethod,
        data: tableData.tableItem
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },

  editUser ({ commit }, tableData) {
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({
        url: `${tableData.endpoint}`,
        method: httpmethod,
        data: tableData.tableItem
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  deleteUser ({ commit }, tableData) {
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({
        url: `${tableData.endpoint}`,
        method: httpmethod
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  approveUser ({ commit }, tableData) {
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({
        url: `${tableData.endpoint}`,
        method: httpmethod
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },

  deleteProject ({ commit }, tableData) {
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({
        url: `${tableData.endpoint}`,
        method: httpmethod,
        data: tableData.tableItem
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  addProject ({ commit }, tableData) {
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({
        url: `${tableData.endpoint}`,
        method: httpmethod,
        data: tableData.tableItem
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  }
}
